class SimpleSunscreenPackPicker extends HTMLElement {
  connectedCallback() {
    this.radios = Array.from(this.querySelectorAll('input[type="radio"][data-pack-option]'));
    this.quantityInput = this.querySelector('[data-pack-quantity]');
    this.productForm = this.querySelector('product-form-component');
    this.mainButton = this.querySelector('[ref="addToCartButton"]');
    this.mainButtonText = this.querySelector('[data-pack-submit-text]');
    this.stickyBar = this.querySelector('[data-pack-sticky]');
    this.stickyPack = this.querySelector('[data-sticky-pack]');
    this.stickyPrice = this.querySelector('[data-sticky-price]');
    this.stickyButton = this.querySelector('[data-sticky-submit]');

    this.radios.forEach((radio) => {
      radio.addEventListener('change', () => this.selectPack(radio, true, true));
    });

    this.stickyButton?.addEventListener('click', () => this.mainButton?.click());

    const url = new URL(window.location.href);
    const requestedPack = url.searchParams.get('pack');
    const requestedRadio = this.radios.find(
      (radio) => radio.dataset.packCount === requestedPack && !radio.disabled
    );
    const selected = requestedRadio || this.radios.find((radio) => radio.checked && !radio.disabled) || this.radios.find((radio) => !radio.disabled);

    if (selected) {
      this.selectPack(selected, Boolean(requestedPack || url.searchParams.has('variant')), false);
      this.trackPackEvent('pack_selector_viewed', selected, requestedRadio ? 'deep_link' : 'default');
    }

    if (this.mainButton && this.stickyBar && 'IntersectionObserver' in window) {
      this.buttonObserver = new IntersectionObserver(([entry]) => {
        const hasScrolledPastButton = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        this.stickyBar.toggleAttribute('data-visible', hasScrolledPastButton);
      });
      this.buttonObserver.observe(this.mainButton);
    }
  }

  disconnectedCallback() {
    this.buttonObserver?.disconnect();
  }

  selectPack(radio, updateUrl, trackSelection) {
    const packCount = Number(radio.dataset.packCount || 1);
    const price = radio.dataset.price || '';
    const available = radio.dataset.available === 'true';
    const singularUnit = this.dataset.singularUnit || 'can';
    const pluralUnit = this.dataset.pluralUnit || 'cans';
    const unitLabel = packCount === 1 ? singularUnit : pluralUnit;

    radio.checked = true;
    if (this.quantityInput) this.quantityInput.value = String(packCount);
    if (this.productForm) this.productForm.dataset.quantityDefault = String(packCount);

    if (this.mainButtonText) {
      this.mainButtonText.textContent = available ? `Add ${packCount} ${unitLabel} — ${price}` : 'Sold out';
    }

    if (this.mainButton) this.mainButton.disabled = !available;
    if (this.stickyButton) this.stickyButton.disabled = !available;
    if (this.stickyPack) this.stickyPack.textContent = `${packCount} ${unitLabel}`;
    if (this.stickyPrice) this.stickyPrice.textContent = price;

    if (updateUrl) {
      const url = new URL(window.location.href);
      url.searchParams.set('pack', String(packCount));
      url.searchParams.delete('variant');
      window.history.replaceState({}, '', url);
    }

    if (trackSelection) this.trackPackEvent('pack_selected', radio, 'manual');
  }

  trackPackEvent(eventName, radio, selectionSource) {
    const detail = {
      productId: this.dataset.productId || '',
      quantity: Number(radio.dataset.packCount || 1),
      totalPriceCents: Number(radio.dataset.totalCents || 0),
      unitPriceCents: Number(radio.dataset.unitCents || 0),
      currency: this.dataset.currency || '',
      selectionSource,
    };

    this.dispatchEvent(
      new CustomEvent(`simple-sunscreen:${eventName.replaceAll('_', '-')}`, {
        bubbles: true,
        detail,
      })
    );

    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push({
        event: eventName,
        product_id: detail.productId,
        quantity: detail.quantity,
        value: detail.totalPriceCents / 100,
        unit_price: detail.unitPriceCents / 100,
        currency: detail.currency,
        selection_source: detail.selectionSource,
      });
    }
  }
}

if (!customElements.get('simple-sunscreen-pack-picker')) {
  customElements.define('simple-sunscreen-pack-picker', SimpleSunscreenPackPicker);
}
